import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FieldArray, Form, Formik } from "formik";
import { CircularProgress, createTheme, Divider, Grid2, IconButton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ThemeProvider, Typography, useTheme, } from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { useLazyGetActivityDprDataQuery } from "store/slices/apis/wbsLevelSlice";
import { Grid } from "@mui/system";
import DynamicWbsSelect from "./DynamicWbsSelect";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"


const StyledTableHead = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%', whiteSpace: "nowrap"
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%', whiteSpace: "nowrap"
}));


const columns = [
  {
    name: 'Name',
  },
  {
    name: 'BOQ',
  },
  {
    name: 'Planned Qty Till Date',
  },
  {
    name: 'Executed Qty Till Date',
  },
  {
    name: 'Day',
  },
  {
    name: 'Planned Quantity For Day',
  },
  {
    name: 'Actual Qty',
  },
  {
    name: 'Actual Manpower',
  },
]
export default function AddNewDpr(props) {
  const { open, cancelIssue, openNotification, manageActivities } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [activityDataFun, activityDataRes] = useLazyGetActivityDprDataQuery();
  const [activities, setActivities] = useState([]);
  const [search, setSearch] = useState(false);


  React.useEffect(() => {

    if (activityDataRes?.isSuccess) {
      if (activityDataRes?.data?.data?.length > 0) {
        const enrichedData = activityDataRes?.data?.data?.map(item => ({
          ...item,
          actualQty: '',
          actualManpower: '',
        }));
        setActivities(enrichedData);
      }
    }

  }, [activityDataRes]);

  const handleChange = (index, field, value) => {
    const updated = [...activities];
    updated[index][field] = value;
    setActivities(updated);
  };

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
          },
        },
      },
    },
  });


  const handleClose = () => {
    // setOpen(false);
  };


  const validationSchema = Yup.object().shape({
    wbsLevels: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().required('WBS level field is required.'),
      })
    )
  })

  const handleSubmit = (values, { setSubmitting }) => {
    const formattedValues = {
      ...values,
      reportedDate: values.reportedDate
        ? values.reportedDate.format("YYYY-MM-DD") + "T00:00:00.000000Z"
        : null,
    };

    console.log("Collected Form Data:", formattedValues);
    cancelIssue(false)
    setSubmitting(false);
  };


  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          Search Activity
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent sx={{ padding: '5px 24px 20px 24px' }}>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={{ wbsLevels: [{ id: '', parentId: null, name: null }] }}
                onSubmit={(values) => {
                  const enrichedActivityData = activities?.map(item => ({
                    ...item,
                    wbsLevel: values?.wbsLevels,
                  }));
                  
                  manageActivities((prev) => [...prev, ...enrichedActivityData]);

                  cancelIssue(false);
                }}
                validationSchema={validationSchema}
              >
                {({ values, setFieldValue, touched, errors }) => (
                  <Form>
                    <FieldArray
                      name="wbsLevels"
                      render={(arrayHelpers) => (
                        <Grid container spacing={2}>
                          {values.wbsLevels.map((level, index) => (
                            <DynamicWbsSelect
                              key={index}
                              index={index}
                              level={level}
                              value={level.id}
                              onSelect={(newValue) => {

                                const newId = newValue?.id || '';

                                // Update current level
                                setFieldValue(`wbsLevels[${index}].id`, newId);

                                // Remove all deeper levels properly
                                const newLevels = values.wbsLevels.slice(0, index + 1);

                                // Update current level with new data
                                newLevels[index] = {
                                  id: newId,
                                  parentId: level.parentId,
                                  name: newValue?.name
                                };

                                // Add next level if current selection is valid
                                if (!newValue?.isLeaf && newId) {
                                  newLevels.push({ id: '', parentId: newId, name: null });
                                  setSearch(false)
                                } else {
                                  if (newValue != null) {
                                    activityDataFun({ projectid: projectId, activityId: newId });
                                    setSearch(true)
                                  } else {
                                    setSearch(false)
                                    setActivities([]);
                                  }
                                }

                                // Replace entire array to ensure Formik tracks changes
                                setFieldValue('wbsLevels', newLevels);
                              }}
                              touched={touched?.wbsLevels?.[index]?.id}
                              error={errors?.wbsLevels?.[index]?.id}
                            />
                          ))}
                          <Grid2 size={12}>
                            {search &&
                              <TableContainer>
                                <Table sx={{ border: '1px solid #E9E9E7', borderRadius: '4px' }}>
                                  <TableHead>
                                    <TableRow>
                                      {columns?.map((col, index) => {
                                        return (<StyledTableHead

                                          key={`${col?.name}-${index}`}
                                        >
                                          {col?.name}
                                        </StyledTableHead>)
                                      }
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {activityDataRes?.isLoading ? (
                                      <TableRow>
                                        <StyledTableRow colSpan={columns.length}>
                                          <CircularProgress sx={{ animationDuration: '2s', color: "#C05222" }} />
                                        </StyledTableRow>
                                      </TableRow>
                                    )
                                      :
                                      activities?.length > 0 ?
                                        activities?.map((item, index) => {
                                          return (
                                            <TableRow key={index}>
                                              <StyledTableRow>
                                                {item?.name}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                {item?.boq}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                {item?.planned_Qty_Till_Date}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                {item?.executed_Qty_Till_Date}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                {item?.day}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                {item?.planned_Qty_For_Day}
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                <TextField
                                                  id="outlined-multiline-static2"
                                                  type="number"
                                                  label="Actual Qty"
                                                  fullWidth
                                                  size="small"
                                                  value={item.actualQty}
                                                  onChange={(e) => handleChange(index, 'actualQty', e.target.value)}
                                                  slotProps={{ inputLabel: { shrink: true } }}
                                                  variant="filled"
                                                />
                                              </StyledTableRow>
                                              <StyledTableRow>
                                                <TextField
                                                  id="outlined-multiline-static2"
                                                  type="number"
                                                  label="Actual Manpower"
                                                  fullWidth
                                                  size="small"
                                                  value={item.actualManpower}
                                                  onChange={(e) => handleChange(index, 'actualManpower', e.target.value)}
                                                  slotProps={{ inputLabel: { shrink: true } }}
                                                  variant="filled"
                                                />
                                              </StyledTableRow>
                                            </TableRow>
                                          )
                                        })
                                        :
                                        <TableRow>
                                          <StyledTableRow colSpan={columns?.length}>
                                            Record not found.
                                          </StyledTableRow>
                                        </TableRow>
                                    }
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            }

                          </Grid2>


                          {activities?.length > 0 && activities.every(item => item?.actualManpower != '' && item?.actualQty != '') &&
                            <Grid2 size={12}>
                              <Button
                                type='submit'
                                // loading={addWorkflowRes?.isLoading}
                                variant="contained"
                                sx={{
                                  backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                                  color: '#FFF', padding: '7px 20px',
                                  fontWeight: '500', textTransform: 'none',
                                  fontSize: '16px', float: 'right'
                                }}>
                                Add
                              </Button>
                            </Grid2>
                          }

                        </Grid>
                      )}
                    />
                  </Form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
